import React, { useContext, useEffect, useState } from "react";
import PlusIcon from "assets/icons/Plus.svg";
import { useNavigate } from "react-router-dom";
import { UserContext } from "context/UserContext.jsx";
import { useStatisticsData } from "context/StatisticsData";
import AddPropertyForm from "./properties/AddProperty";

const EmptyActivities = ({
  label = "",
  description = "",
  img = "",
  additionalButton = "",
  buttonLabel = "Post a job",
  onButtonClick = null,
}) => {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const { statisticsData, fetchStatistics } = useStatisticsData();

  // Modal state for Add Property
  const [showAddPropertyModal, setShowAddPropertyModal] = useState(false);
  const [addPropertyId, setAddPropertyId] = useState(null);

  useEffect(() => {
    if (!statisticsData) {
      // Prefetch stats if missing so we can decide the flow correctly
      try {
        fetchStatistics();
      } catch {}
    }
  }, []);

  const handleButtonClick = () => {
    if (buttonLabel === "Add first property" && onButtonClick) {
      onButtonClick();
    } else if (buttonLabel === "Post a job") {
      const total = statisticsData?.totalProperties;
      if (typeof total === "number" && total === 0) {
        // Open Add Property modal before proceeding to post job
        setShowAddPropertyModal(true);
      } else {
        // Normal post job flow
        navigate("/post-job");
      }
    }
  };

  return (
    <div className="md:py-12 py-6 md:px-6 px-4  m-auto flex flex-col items-center  ">
      {/* Add Property Modal - gated before posting a job */}
      {showAddPropertyModal && (
        <AddPropertyForm
          setModalState={() => {
            // Close modal on any internal state change
            setShowAddPropertyModal(false);
            setAddPropertyId(null);
          }}
          onSuccess={() => {
            // After adding a property, proceed to post job
            setShowAddPropertyModal(false);
            setAddPropertyId(null);
            navigate("/post-job");
          }}
          setPropertyId={setAddPropertyId}
          propertyId={addPropertyId}
        />
      )}

      <img
        src={img}
        alt="empty-state"
        className="mb-8 w-[174px] h-[144px] "
      />
      <h2 className="text-[#22424] font-[500] mb-3">{label}</h2>
      <h4 className="text-[#333333]   font-[500] mb-5 ">{description}</h4>
      <div className="flex gap-5 items-center">
        {" "}
        {/*{additionalButton && (*/}
        {/*  <button className="bg-[#F8F8F8] flex gap-2 border-[#ECECEC] text-[#242424]  w-fit    px-3 sm:text-[14px] lg:text-[16px] xl:text-[18px]   py-3 rounded-xl font-medium">*/}
        {/*    <img src={ViewIcon}></img>*/}
        {/*    View job listings*/}
        {/*  </button>*/}
        {/*)}*/}
        {userData.accountType !== "VENDOR" && (
          <button
            onClick={handleButtonClick}
            className="bg-[#3cab5c] flex gap-2   w-fit hover:bg-[#3c8f47] text-white  px-3 sm:text-[14px] lg:text-[16px] xl:text-[18px]   py-3 rounded-xl font-medium"
          >
            <img src={PlusIcon} alt="plus" /> {buttonLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyActivities;
